export interface Branding {
  workspace_name: string;
  primary_color: string;
  logo_url: string;
  tagline?: string;
  favicon_url?: string;
}

export const defaultBranding: Branding = {
  primary_color: '#1E40AF',
  logo_url: '',
  workspace_name: '',
};
